// apps/scheduler-worker/src/components/TaskStatusBadge.tsx
import type { TaskStatus } from 'scheduler-types';
import { cn } from 'scheduler-ui';

interface TaskStatusBadgeProps {
  status: TaskStatus;
}

const statusConfig: Record<TaskStatus, { label: string; className: string }> = {
  pending: { label: 'Pending', className: 'bg-gray-100 text-gray-700' },
  ready: { label: 'Ready', className: 'bg-blue-100 text-blue-700' },
  staged: { label: 'Staged', className: 'bg-purple-100 text-purple-700' },
  partial_staged: { label: 'Partial', className: 'bg-amber-100 text-amber-700' },
  in_progress: { label: 'In Progress', className: 'bg-green-100 text-green-700' },
  complete: { label: 'Complete', className: 'bg-green-200 text-green-800' },
  cancelled: { label: 'Cancelled', className: 'bg-gray-200 text-gray-600' },
  abandoned: { label: 'Abandoned', className: 'bg-red-100 text-red-700' },
};

export function TaskStatusBadge({ status }: TaskStatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium',
        config.className
      )}
    >
      {config.label}
    </span>
  );
}
